import { FC } from 'react'
import {
  Typography,
  STextField,
  materialLab,
  Popper,
  PopperProps
} from '../../..'
import { icons } from 'assets'
import { useClassName } from 'hooks'
import useStyles from './styles'
import { AutocompleteProps } from './types'

const Autocomplete: FC<AutocompleteProps> = ({
  className,
  label,
  options,
  value,
  placeholder = '',
  onChange,
  error = false,
  classes: classesProp,
  titleClassName = '',
  multiple = false,
  disabled,
  labelClassName = '',
  inputProps,
  popperWidth = '300px',
  popperStyles
}) => {
  const classes = useStyles()
  const classNames = useClassName()

  const PopperMy = (props: JSX.IntrinsicAttributes & PopperProps) => {
    return (
      <Popper
        {...props}
        className={classes.popper}
        placement='bottom-start'
        style={{ width: popperWidth, ...popperStyles, }}
      />
    )
  }

  return (
    <>
      {label && <Typography variant="body1" className={classNames(classes.title, titleClassName, labelClassName)}>
        {label}
      </Typography>}
      <materialLab.Autocomplete
        options={options}
        getOptionLabel={option => option.value}

        renderInput={(params) => (
          <STextField
            {...params}
            InputProps={{
              ...params.InputProps,
              ...inputProps
            }}
            variant='standard'
            label=''
            // error={error}
            placeholder={placeholder}
            className={classNames(
              classes.textfield,
              className || '',
              error ? classes.inputError : ''
            )}

          />
        )}
        classes={{
          root: classes.root,
          endAdornment: classes.endAdornment,
          clearIndicatorDirty: classes.clearIndicator,
          popupIndicator: classes.popupIndicator,
          popupIndicatorOpen: classes.popupIndicator,
          listbox: classes.listBox,
          option: classes.option,
          ...classesProp
        }}
        getOptionSelected={(option, value) => {
          if (value?.key === '' || value === null) return true;
          return option?.key === value?.key
        }}
        value={value}
        onChange={(_event, value) => {
          onChange(value)
        }}
        PopperComponent={PopperMy}
        popupIcon={<icons.KeyboardArrowDown />}
        multiple={multiple}
        disabled={disabled}
      />
    </>
  )
}

export default Autocomplete
